import './Separation.css';

export function Separation(props: {
   direction: 'horizontal' | 'vertical';
   text?: {
      text: string;
      backgroundColor?: string;
      color?: string;
   };
   separationColor?: string;
}) {
   return (
      <div
         className={`separation ${props.direction}`}
         style={{
            backgroundColor: props.separationColor ?? 'var(--dark-gray)',
         }}>
         {props.text && (
            <p
               style={{
                  backgroundColor: props.text.backgroundColor ?? ' black',
                  color: props.text.color ?? 'var(--light-gray)',
               }}>
               {props.text.text}
            </p>
         )}
      </div>
   );
}
